const ModalHelper = {
	data() {
		return {
			loading: false,
			showErrors: false,
			showErrorsBlacklist: false,
			errors: {},
			open: false,
		}
	},
	methods: {
		closeModal() {
			// Enable scroll on modal parent
			document.querySelector('body').classList.remove('overflow-hidden')

			// Resets props
			this.open = !this.open
			this.showErrors = false
			this.errors = {}
		},
		openFeedbackFormModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-feedback-form-modal', {
				request: this.request,
			})
		},
		openLoginModal() {
			// Block scroll on modal parent and close overlay
			document.querySelector('body').classList.add('overflow-hidden')
			document.querySelector('body').classList.remove('overlay-active')

			// Emit open event
			this.$root.$emit('open-login-modal')
		},
		openNewsletterAuthorizationsModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-newsletter-authorizations-modal')
		},
		openProfileDeleteModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-profile-delete-modal')
		},
		openRefundCreditsModal(credit) {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-refund-credits-modal', {
				credit,
			})
		},
		openRefundRequestModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-refund-request-modal', {
				request: this.request,
			})
		},
		openRequestRetireModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-request-retire-modal', {
				request: this.request,
			})
		},
		openRequestUpgradeModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-request-upgrade-modal', {
				request: this.request,
			})
		},
		openResponseChooseLawyerModal() {
			if (this.isResponseAccepted) {
				// Block scroll on modal parent
				document.querySelector('body').classList.add('overflow-hidden')

				// Emit open event
				this.$root.$emit('open-response-choose-lawyer-modal', {
					response: this.response,
				})
			}
		},
		openResponseChooseOptionsAcceptModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-response-choose-options-accept-modal', {
				response: this.response,
			})
		},
		openResponseChooseOptionsDeclineModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-response-choose-options-decline-modal', {
				response: this.response,
			})
		},
		openUploadAttachmentModal() {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-upload-attachment-modal', {
				response: this.response,
			})
		},
	},
}

export default ModalHelper



// WEBPACK FOOTER //
// ./src/mixins/ModalHelper.js